import { useState } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Link } from 'react-router';
import { requete } from '../../api/client';
import { messageErreur } from '../../api/erreurs';
import { useSession } from '../../session/FournisseurSession';
export function SuggestionsSignalement({ id, version }: { id: string; version: number }) {
  const { contexte } = useSession();
  const client = useQueryClient();
  const [ouvert, setOuvert] = useState(false);
  const [occupe, setOccupe] = useState(false);
  const [erreur, setErreur] = useState('');
  const q = useQuery({
    queryKey: ['suggestions-signalement', contexte?.appartenance_active?.id, id, version],
    enabled: ouvert,
    queryFn: () =>
      requete<{
        tronque: boolean;
        elements: {
          id: string;
          reference: string;
          titre: string;
          distance_metres: number | null;
          raison: string;
        }[];
      }>(`/signalements/${id}/suggestions`),
  });
  return (
    <details onToggle={(e) => setOuvert(e.currentTarget.open)}>
      <summary>Rechercher des incidents similaires</summary>
      <p>
        Même organisation, service, province et catégorie, dates de création espacées de 7 jours
        maximum. Distance à vol d’oiseau de 2 km maximum si les coordonnées sont disponibles ;
        sinon, libellé de localisation identique. Vérifiez les dossiers avant tout rattachement : la
        proximité ne prouve pas une cause commune.
      </p>
      {ouvert && q.isPending && <p role="status">Recherche…</p>}
      {(erreur || q.error) && <p role="alert">{erreur || messageErreur(q.error)}</p>}
      {q.data?.tronque && <p role="alert">Seules les 20 premières suggestions sont affichées.</p>}
      {q.data && !q.data.elements.length && (
        <p>Aucun incident similaire trouvé avec ces critères.</p>
      )}
      {!!q.data?.elements.length && (
        <form
          style={{ display: 'grid', gap: 12, maxWidth: 700 }}
          onSubmit={async (e) => {
            e.preventDefault();
            const d = new FormData(e.currentTarget);
            setOccupe(true);
            setErreur('');
            try {
              await requete(`/signalements/${id}/qualification`, {
                methode: 'POST',
                corps: {
                  action: 'rattacher',
                  version,
                  incident_id: d.get('incident_id'),
                  motif: d.get('motif'),
                },
              });
              await client.invalidateQueries({ queryKey: ['signalements-reseau'] });
              await client.invalidateQueries({ queryKey: ['incidents-reseau'] });
            } catch (err) {
              setErreur(messageErreur(err));
            } finally {
              setOccupe(false);
            }
          }}
        >
          <fieldset>
            <legend>Incident à vérifier puis à sélectionner</legend>
            {q.data!.elements.map((i) => (
              <div key={i.id} style={{ marginBlock: 12 }}>
                <label>
                  <input type="radio" name="incident_id" value={i.id} required /> {i.reference} —{' '}
                  {i.titre}
                </label>
                <p>
                  {i.raison === 'PROXIMITE'
                    ? `Distance approximative : ${i.distance_metres} m`
                    : 'Même libellé de localisation (distance non calculée)'}
                </p>
                <Link to={`/incidents/${i.id}`}>Consulter {i.reference}</Link>
              </div>
            ))}
          </fieldset>
          <label>
            Motif du rapprochement <input name="motif" required minLength={3} maxLength={500} />
          </label>
          <button disabled={occupe}>Confirmer le rattachement choisi</button>
        </form>
      )}
    </details>
  );
}
